import axios from "axios";

import { activateFirebaseConfig } from "../../api/firebaseApi";
import { apiUrlActions } from "../api/api-url-slice";
import { authActions } from "./auth-slice";

// const asyncsessionStorage = {
//   async setItem(key: any, value: any) {
//     await null;
//     return sessionStorage.setItem(key, value);
//   },
// };

export const login = (loginData: string, suffix: string) => {
  return async (dispatch: any): Promise<void> => {
    try {
      const API_URL = await activateFirebaseConfig(suffix);
      sessionStorage.setItem("apiUrl", `${API_URL}/web`);
      // window.apiUrl = `${API_URL}/web`;
      // await
      dispatch(apiUrlActions.login(`${API_URL}/web`));

      const response = await axios.post(
        `${API_URL}/app/access/login`,
        loginData,
        {
          timeout: 5000,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );

      await dispatch(
        authActions.login({
          token: response.data.token,
          id: response.data.id,
        })
      );
      sessionStorage.setItem("token", response.data.token);
      sessionStorage.setItem("userId", response.data.id);
      sessionStorage.setItem("insert", response.data.podeInserir);
      sessionStorage.setItem("delete", response.data.podeExcluir);
      // sessionStorage.setItem('userName', response.data.id);
      // sessionStorage.setItem("master", response.data.master);
    } catch (err: any) {
      // console.log(err.message);
      let errorMessage = "Erro no login";
      if (err.message && err.message === "Network Error") {
        errorMessage = `Verifique sua conexão com a internet,
                        ou entre em contato com o administrador do sistema`;
      }
      if (
        err.message &&
        err.message === "Request failed with status code 401"
      ) {
        errorMessage = "Usuário ou senha incorretos";
      }
      throw new Error(errorMessage);
    }
  };
};

export const logout = () => {
  sessionStorage.clear();
  return async (dispatch: any): Promise<void> => {
    dispatch(apiUrlActions.logout());
    dispatch(authActions.logout());
  };
};
